import { get, cloneDeep } from 'lodash';
import { equals, mergeDeepRight, is } from 'ramda';
import {
  setBSCenterAddress as setBSCenterAddressEvent,
  suggestionChange,
  addressSelect,
  validateAddress as validateAddressEvent,
  mapDragEnd,
  updateMap,
  resetValidation,
  setGeoObject,
  geoObjectProcessed,
  geoObjectUpdate,
  removeJkMarkers,
  mapReady,
  geocodeStart
} from './address.events';
import app from '../../../scripts/app';
import { isNewOffer } from '../../../scripts/services/ad-state.service';
import template from './address.jade';
import { getUndergroundDistance } from '../../../scripts/services/geo.service';
import { trackReportAddressModalOpen } from './Address.tracking';

const MAX_METRO_STATIONS = 3;

app.directive('cianAfAddress', () => {
  return {
    template,
    scope: {},
    bindToController: {
      category: '@',
      categoryInfo: '=',
      ad: '=',
      form: '=',
    },
    controller: [
      'jkService', 'pubAvailService', 'addressService', 'apiService', 'userService', 'popupService', '$timeout', '$q',
      '$rootScope', '$scope', 'btiService', 'bsCenterService', 'addFormLayoutService', 'geoService', 'deviceService',
      'telemetryService',
      function (
        jkService, pubAvailService, addressService, apiService, userService, popupService, $timeout, $q, $rootScope,
        $scope, btiService, bsCenterService, addFormLayoutService, geoService, deviceService, telemetryService
      ) {
        this.isMobile = deviceService.isMobile;
        this.layoutService = addFormLayoutService;

        this.defaultSegmentConfig = [
          'cian-af-address-user-input',
          'cian-af-address-map',
          'cian-af-address-underground',
        ];

        if (!is(Object, this.ad.geo)) {
          this.ad.geo = {};
        }

        let isMapReady = false;
        let isAddressFullyInitialized = false;
        let lastGeoObjectPromise;

        const geoCache = {};
        const isGeoPromiseLast = promise => promise === lastGeoObjectPromise;
        const defaultUserCity = get(geoService, 'userGeo.name', 'Москва');
        const defaultUserInput = `Россия, ${defaultUserCity} `;
        const defaultLocationId = get(geoService, 'userGeo.id', 1);

        // Формируем начальный геообъект, т.к из-за отсутствия первого запроса на геокод он не будет
        // определен. Необходим для поддержки клиентской валидации гео-строки.
        const defaultGeo = {
          accuracyError: null,
          coordinates: {
            lat: geoService.userGeo.lat,
            lng: geoService.userGeo.lng
          },
          geoId: defaultLocationId,
          status: 'needAddress',
          hasMetro: geoService.userGeo.hasUnderground,
          locationId: defaultLocationId,
          locationPath: [defaultLocationId],
          text: defaultUserInput
        };

        this.geoObject = mergeDeepRight(defaultGeo, this.ad.geo);

        // Хелперы контроллера
        const setUserLocation = () => {
          this.ad.geo.userInput = defaultUserInput;
          addressService.locationId = defaultLocationId;
          geoService.setLocationPathAndCoordinates(geoService.getLocationPath(), geoService.getCoordinates());
        };

        const setInitialGeo = () => {
          this.ad.geo.address = [];
          this.ad.geo.countryId = 138;
          this.ad.geo.highways = [];
          this.ad.geo.undergrounds = [];
          this.ad.geo.geoId = null;
          this.ad.geo.geoType = null;

          if (this.form['geo.userInput']) {
            this.form['geo.userInput'].$setPristine();
          }

          if (isNewOffer) {
            jkService.initializeEmptyJK({ force: true });
          }

          setUserLocation();

          if (!this.ad.geo.address || !this.ad.geo.address[0]) {
            $rootScope.$emit(resetValidation);
          }
        };

        const initGeoObject = () => {
          setInitialGeo();

          return $timeout(() => {
            setUserLocation();
          });
        };

        const clearGeoAddress = status => {
          if (!status) {
            setInitialGeo();
            setMap(this.ad.geo.userInput, true, false);
          } else if (status === 'newCategory') {
            this.geoObject = null;
            setInitialGeo();
            this.ad.geo.userInput = null;
            addFormLayoutService.setShortForm(false);
            changeAddress(getGeoObjectFromAd(), false, false, true, false, false);
          } else {
            this.ad.geo.address = [];
            this.ad.geo.geoId = null;
            this.ad.geo.geoType = null;
            this.geoObject = {
              status,
            };
            $rootScope.$emit(geoObjectUpdate, this.geoObject);
          }
        };

        const setGeoCache = (addressString, geoObject) => {
          geoCache[addressString] = geoObject;
        };

        const getGeoCache = addressString => {
          return geoCache[addressString] || null;
        };

        const getGeoObject = (addressString, isForcedFetch = false, category = this.ad.category) => {
          const deferred = $q.defer();
          lastGeoObjectPromise = deferred.promise;

          if (angular.isString(addressString)) {
            addressString = addressString.trim();
          }
          if (this.geoObjectDeffered) {
            this.geoObjectDeffered.resolve();
          }
          this.geoObjectDeffered = $q.defer();
          if (!addressString) {
            deferred.reject('notFound');
          } else {
            const cachedGeoObject = getGeoCache(addressString);
            if (!isForcedFetch && cachedGeoObject) {
              if (angular.isObject(cachedGeoObject)) {
                deferred.resolve(cachedGeoObject);
              } else {
                deferred.reject(cachedGeoObject);
              }
              if (isGeoPromiseLast(deferred.promise)) {
                $rootScope.$emit(geoObjectProcessed, false);
              }
            } else {
              $rootScope.$emit(geoObjectProcessed, true);

              const params = {
                request: addressString,
                category,
                checkLocality: false,
              };

              $rootScope.$emit(geocodeStart);

              telemetryService.mark('addform.geocode-start');

              apiService.geocode({
                timeout: this.geoObjectDeffered.promise,
                params,
              }).then((res) => {
                telemetryService.mark('addform.geocode-end');
                telemetryService.sendMeasuredTimer(
                  'addform.geocode-request',
                  'addform.geocode-start',
                  'addform.geocode-end',
                );

                if (res && res.data && res.data.data) {
                  const geoObject = res.data.data;

                  if (Array.isArray(geoObject.underground)) {
                    geoObject.underground.splice(MAX_METRO_STATIONS);
                  }

                  setGeoCache(addressString, geoObject);

                  deferred.resolve(geoObject);
                } else {
                  deferred.reject('serverError');
                }

                if (isGeoPromiseLast(deferred.promise)) {
                  $rootScope.$emit(geoObjectProcessed, false);
                }
              }, response => {
                if (response.status === 404) {
                  setGeoCache(addressString, 'notFound');
                  deferred.reject('notFound');
                } else {
                  deferred.reject('serverError');
                }

                if (isGeoPromiseLast(deferred.promise)) {
                  $rootScope.$emit(geoObjectProcessed, false);
                }
              });
            }
          }

          return deferred.promise;
        };

        const updateJk = (geoObj) => {
          // Для проблемных ЖК во вторички, теперь нам при выборе адреса, к которому привязан ЖК необходимо запрашивать
          // информацию о ЖК чтобы понять проблемный он или нет.
          let promise;
          const { geoId, geoType } = geoObj;

          if (this.ad.category === 'flatSale') {
            promise = jkService.getJkByGeoObj({ id: geoId, type: geoType }).then(jk => {
              if (jk) {
                const jkData = jk;
                const JKHouse = jk && jk.houses[0];
                jkData.house = jk && jk.houses[0];
                if (jkData) {
                  this.ad.geo.jk = jkData;
                }
                if (JKHouse) {
                  this.ad.geo.jk.house = JKHouse;

                  // Если это ЖК, добавляем специальный хеш в объект по ID корпуса
                  // Если этого не сделать, может быть такая ситуация что ЖК locationPath и locationPath корпуса совпадают
                  // И после выбора такого корпуса установка адреса может быть пропущена, и метро не установится и форма не схлопнется
                  geoObj.jkHashKey = JKHouse.id;
                }
              }
            });
          } else {
            promise = Promise.resolve();
          }

          return promise;
        };

        const setGeoAddress = (geoObject) => {
          this.ad.geo.coordinates = geoObject.coordinates;
          this.ad.geo.address = [];
          this.ad.geo.details = geoObject.details;
          this.ad.geo.geoId = geoObject.geoId;
          this.ad.geo.geoType = geoObject.geoType;

          // Массив гео информации в порядке ParentToChild (от наиболее общего гео к конкретному), например [регион, район, дом]
          // В таком порядке гео информация хранится в поле ad.geo.address. Это поле отправляется на сервер
          // при сохранении черновика (не активного) и при публикации объявления.
          // Клонируем, чтобы не изменить locationPath в geoObject, так как reverse работает in-place.
          const locationPath = get(geoObject, 'locationPath', []) || []; // get может возвращать null при locationPath null
          const locationPathParentToChild = cloneDeep(locationPath).reverse();
          const newAddress = locationPathParentToChild.map(id => ({ id, type: 'location' }));

          /**
           * Ищем в массиве нового адреса наш геообъект
           * Если находим, выставляем ему верный тип
           * Если не находим, добавляем его в массив адреса
           */
          const geoIdFromAddress = newAddress.find(item => item.id === geoObject.geoId);
          if (geoIdFromAddress) {
            geoIdFromAddress.type = geoObject.geoType;
          } else {
            newAddress.push({
              id: geoObject.geoId,
              type: geoObject.geoType,
            });
          }

          this.ad.geo.address = newAddress;
          this.geoObject = geoObject;
        };

        const changeAddress = (geoObject, validate, searchBSByAddress = true, init, isJk, firstLoad) => {
          setGeoAddress(geoObject);

          if (geoObject.locationPath && geoObject.locationPath.length) {
            geoService.setLocationPathAndCoordinates(geoObject.locationPath, geoObject.coordinates);
          }

          let isAddressValid;
          if (validate) {
            isAddressValid = validateAddress();
          }

          const addressChanged = addressService.saveAddress(this.ad.geo.address, geoObject, isAddressValid, init, isJk, firstLoad, searchBSByAddress);

          updateJk(geoObject).then(() => {
            // todo: перенести в addFormController после рефакторинга гео
            if (addressChanged && !init && !firstLoad) {
              if (bsCenterService.isBSCategory()) {
                // для БЦ короткий лэйаут включается сразу, а на короткую форму переключаемся только после привязки БЦ
                if (searchBSByAddress) { // адрес введен вручную - открепляем старый БЦ и ищем новый, если адрес до дома
                  bsCenterService.detachBSCenter();
                  if (addressService.isHouse()) {
                    bsCenterService.fillBSCenterDataByAddress()
                      .then(bsCenter => {
                        addFormLayoutService.setLayout();

                        if (bsCenter) {
                          updateGeoFromBSCenter(bsCenter.geo);
                          addFormLayoutService.setRevertValues();
                        }

                        if (addFormLayoutService.isShortLayout) {
                          addFormLayoutService.setShortForm(!!bsCenter);
                        }
                      })
                      .catch((err) => {
                        // TODO не передавать ошибку строкой, а мб каким-то статусом или еще чем, надо подумать
                        if (err === 'bs_centers is empty' && btiService.isBtiCommercialCategory() && addressService.isHouse()) {
                          return btiService.processBti(this.ad)
                            .then(function () {
                              if (addFormLayoutService.isShortLayout) {
                                $timeout(() => { // Хак, если без $timeout поле building.statusType не заполняется, не понял почему
                                  addFormLayoutService.setShortForm(true);
                                }, 0);
                              }
                            });
                        }

                        return $q.reject();
                      });
                  }
                }
              } else if (btiService.isBtiCategory()) {
                // для БТИ включаем короткий лэйаут только когда указан адрес до дома
                if (addressService.isHouse()) {
                  btiService.processBti(this.ad);
                } else {
                  addFormLayoutService.setLayout();
                }
              } else if (jkService.isJkSelected() && !jkService.hasProblems()) {
                addFormLayoutService.setLayout();
              }
            }

            if (firstLoad) addFormLayoutService.setLayout();
          });
        };

        /**
         *
         * @param addressString
         * @param firstLoad - true - если первый запуск при создании нового объявления
         * @param needValidate
         * @param searchBSByAddress
         * @param init - true если первый запуск (инициализация карты) - при открытии на редактирование сохраненного объявления
         * или активного черновика, или при первом переключении на полный вид с короткого
         */
        const setMap = (addressString, firstLoad, needValidate, searchBSByAddress, init, isSuggest) => {
          const promise = getGeoObject(addressString);
          needValidate = true;

          return promise.then(
            geoObject => {
              // если это адрес из саджеста, то только обновляем карту
              if (isSuggest && !firstLoad) {
                $rootScope.$emit(updateMap, geoObject);
              } else {
                return $timeout(() => {
                  if (needValidate && isGeoPromiseLast(promise)) {
                    if (firstLoad && this.ad.geo.coordinates && this.ad.geo.coordinates.lat && this.ad.geo.coordinates.lng) {
                      geoObject.coordinates.lat = Number(this.ad.geo.coordinates.lat);
                      geoObject.coordinates.lng = Number(this.ad.geo.coordinates.lng);
                    }

                    // для привязанных к каталогу ЖК берем координаты и метро из каталога, все остальное - из геокодера
                    const jkGeo = addressService.getJkGeo();
                    const isJk = isJkFromCatalog();

                    if (isJk) {
                      if (jkGeo.coordinates) {
                        geoObject.coordinates = jkGeo.coordinates;
                      }

                      if (jkGeo.underground) {
                        geoObject.underground = jkGeo.underground;
                      }
                    }
                    changeAddress(geoObject, !firstLoad, firstLoad ? false : searchBSByAddress, init, isJk, firstLoad);

                    $rootScope.$emit(updateMap, geoObject);
                  }
                });
              }
            },
            status => {
              bsCenterService.detachBSCenter();
              $timeout(() => {
                if (needValidate && isGeoPromiseLast(promise)) {
                  clearGeoAddress(status);
                  if (!firstLoad) {
                    validateAddress();
                  }
                  $rootScope.$emit(geoObjectProcessed, false);
                }
              });
            }
          );
        };

        const setGeoUserInput = addressString => {
          this.ad.geo.userInput = addressString;
        };

        const setAddressByCoords = coords => {
          getGeoObject(coords).then(
            geoObject => {
              setGeoUserInput(geoObject.text || geoObject.name);

              if (geoObject.geoType !== 'house') {
                let [lng, lat] = coords.split(',');

                geoObject.coordinates = geoObject.coordinates || {};

                geoObject.coordinates.lng = lng;
                geoObject.coordinates.lat = lat;
              }

              changeAddress(geoObject, true);
            },
            status => {
              clearGeoAddress(status);
              validateAddress();
            }
          );
        };

        /**
         * Определяет привязан ли выбранный ЖК к каталогу по соответствию введенного адреса адресу из каталога.
         * @returns {boolean|undefined} true/false если ЖК выбран, иначе - undefined
         */
        const isJkFromCatalog = () => {
          if (!jkService.isJkCategory()) return false;
          const jkGeo = addressService.getJkGeo();
          const addressString = this.ad.geo.userInput && this.ad.geo.userInput.trim();
          if (jkGeo)
            return addressString === jkGeo.address;
        };
        /**
         * Валидация адреса.
         * Адрес из каталога ЖК и БЦ считаем валидным.
         */
        const validateAddress = (sync = false) => {
          const isFromCatalog = isJkFromCatalog() || bsCenterService.isBSCenterAttached();
          const status = get(this.geoObject, 'status');
          const isServerError = status === 'serverError';
          const isNotFound = status === 'notFound';

          if (window.skipAddressValidation || (isFromCatalog && !(this.geoObject && (isServerError || isNotFound))) || !this.geoObject) {
            $rootScope.$emit(resetValidation, true);
          } else {
            let isAddressValid;
            const removeListener = $rootScope.$on('geo.address.validated', (event, valid) => isAddressValid = valid);
            $rootScope.$emit(validateAddressEvent, this.geoObject, sync);
            removeListener();

            return isAddressValid;
          }
        };

        // введен новый адрес
        const selectAddress = (needValidate, searchBSByAddress) => {
          setMap(this.ad.geo.userInput, false, needValidate, searchBSByAddress);
        };

        const updateCategoryConditions = (newCategory, oldCategory) => {
          if (isNewOffer && newCategory !== 'newBuildingFlatSale' && !bsCenterService.isBSCategory(newCategory)) {
            jkService.initializeEmptyJK({ force: true });
          }

          this.title = newCategory == 'newBuildingFlatSale' ? 'Жилой комплекс' : (bsCenterService.isBSCategory(newCategory) ? 'Адрес или название бизнес-центра' : 'Адрес');

          if (newCategory !== oldCategory) {
            if (!this.ad.coworkingOfferType ||
              (newCategory !== '' && oldCategory !== 'officeRent') ||
              (newCategory !== 'officeRent' && oldCategory !== '')) {
              $rootScope.$emit(removeJkMarkers);
            }

            if (oldCategory && (newCategory === '' || newCategory)) {
              if (this.ad.geo.userInput !== defaultUserInput || this.form['geo.userInput'].$dirty) {
                getGeoObject(this.ad.geo.userInput, true, newCategory).then((geoObject) => {
                  this.geoObject = geoObject;

                  validateAddress();
                });
              } else {
                $rootScope.$emit(resetValidation);
              }
            } else if (oldCategory && !newCategory) {
              clearGeoAddress('newCategory');
              $rootScope.$emit(resetValidation);
            } else if (this.ad.geo.userInput !== defaultUserInput) {
              validateAddress();
            } else {
              $rootScope.$emit(resetValidation);
            }

            setGeoCache(this.ad.geo.userInput, null);
            setMap(this.ad.geo.userInput, false, true);
          }
        };

        const updateGeo = (geo, searchBSByAddress) => {
          if (geo.address) {
            this.ad.geo.userInput = geo.address;
            selectAddress(true, searchBSByAddress);
          }

          if (Array.isArray(geo.road) && geo.road[0] && geo.road[0].id) {
            this.ad.geo.highways = geo.road;
          } else {
            this.ad.geo.highways = null;
          }
        };

        const onSuggestionChange = (value, firstLoad) => {
          if (value) {
            setMap(value, firstLoad, true, false, false, true);
          }
        };

        const getGeoObjectFromAd = () => {
          const geoObject = {};

          if (this.ad.geo.coordinates) {
            geoObject.coordinates = this.ad.geo.coordinates;
          }

          if (this.ad.geo.address && this.ad.geo.address.length) {
            const {type, id} = this.ad.geo.address[this.ad.geo.address.length - 1];

            geoObject.geoType = type;
            geoObject.geoId = id;

            // в ad.geo.address приходит порядок ParentToChild,
            // в geoObject.locationId храним id родительского региона
            // (используется потом в запросах к шоссе и метро)
            const location = this.ad.geo.address.filter(a => a.type == 'location')[0];

            if (location) {
              geoObject.locationId = location.id;
            }

            geoObject.locationPath = this.ad.geo.address.filter(a => a.type === 'location').map(i => i.id);
            geoObject.hasMetro = !!window.addFormState.geo.hasUnderground;
          }

          return geoObject;
        };

        const setLocationPathFromAd = () => {
          // В ad.geo.address порядок ParentToChild
          const locationPathParentToChild = this.ad.geo.address
            .filter(geo => geo.type === 'location')
            .map(location => location.id);

          const locationPathChildToParent = locationPathParentToChild.slice().reverse();

          if (locationPathChildToParent && locationPathChildToParent.length > 0) {
            geoService.setLocationPathAndCoordinates(locationPathChildToParent, this.ad.geo.coordinates);
          }
          isAddressFullyInitialized = true;
        };

        const emitGeoObjectChange = (newGeo, oldGeo) => {
          if (!equals(oldGeo, newGeo)) {
            $rootScope.$emit(geoObjectUpdate, newGeo);
          }
        };

        // при выборе бц
        const setBSCenterAddress = (bsCenterGeo, geocode, callback) => {
          if (geocode) {
            setMap(this.ad.geo.userInput, false, true, false, false)
              .then(() => {
                updateGeoFromBSCenter(bsCenterGeo);
                if (callback) callback();
              });
          } else {
            updateGeoFromBSCenter(bsCenterGeo);
          }
        };

        const updateGeoFromBSCenter = bsCenterGeo => {
          if (bsCenterGeo.undergrounds)
            this.ad.geo.undergrounds = bsCenterGeo.undergrounds.map(mapBSCenterUnderground).slice(0, MAX_METRO_STATIONS);
          else
            this.ad.geo.undergrounds = null;
        };

        const mapBSCenterUnderground = (underground) => ({
          ...underground,
          ...getUndergroundDistance(underground),
        });

        this.showReportModal = () => {
          popupService.openPopup('reportAddress', { ad: this.ad });

          trackReportAddressModalOpen();
        };

        // Начало инициализации
        if (!this.ad.geo.userInput) { // новые объявления
          initGeoObject();

          isAddressFullyInitialized = true;
        } else { // редактирование, активный черновик
          addressService.geoObject = getGeoObjectFromAd(); // geoObject.locationPath нужен для определения региона, чтобы узнать включать ли коротокую форму
          addFormLayoutService.setLayout();

          if (addFormLayoutService.isShortForm) {
            if (jkService.isJkCategory()) {
              addressService.setJkGeo({
                address: this.ad.geo.userInput,
                coordinates: this.ad.geo.coordinates,
              });
            }

            addFormLayoutService.setRevertValues();

            setMap(this.ad.geo.userInput, true, true, false, true);

            isMapReady = true;
            setLocationPathFromAd();
          } else {
            $rootScope.$on(mapReady, () => {
              $timeout(() => {
                this.form['geo.userInput'] && this.form['geo.userInput'].$setDirty();

                // Если у нас редактирование объявления, то данные в ad.geo придут от сервера, не надо еще раз устанавливать маркер CSSSR-7036
                setMap(this.ad.geo.userInput, false, true, false, true);

                if (this.ad.geo && this.ad.geo.address) {
                  setLocationPathFromAd();
                }

                isMapReady = true;
                validateAddress();
              });
            });
          }
        }
        // Конец инициализации

        // Все вотчеры и биндинги событий
        const rootScopeListeners = [
          $rootScope.$on(addressSelect, (event, needValidate) => selectAddress(needValidate)),
          $rootScope.$on(suggestionChange, (event, value, firstLoad) => onSuggestionChange(value, firstLoad)),
          $rootScope.$on(mapDragEnd, (event, coords) => setAddressByCoords(coords)),
          $rootScope.$on(setGeoObject, (event, geoObject, searchBSByAddress) => updateGeo(geoObject, searchBSByAddress)),
          $rootScope.$on(setBSCenterAddressEvent, (event, ...args) => setBSCenterAddress(...args)),
        ];

        // при переключении на полную форму, валидируем адрес и обновляем карту нужным адресом
        addFormLayoutService.onIsShortFormChange(({ isShortForm, oldIsShortForm }) => {
          if (!isShortForm && oldIsShortForm) {
            $timeout(() => validateAddress()); // таймаут, потому что директива userInput включится после текущего дайджеста
            const removeListener = $rootScope.$on(mapReady, () => {
              if (this.geoObject) $rootScope.$emit(updateMap, this.geoObject);
              isMapReady = true;
              removeListener();
            });
          }
        });

        $scope.$on('$destroy', () => {
          rootScopeListeners.forEach(i => i());
        });

        $scope.$watch(() => this.category, updateCategoryConditions);
        $scope.$watch(() => this.geoObject, emitGeoObjectChange);
        $scope.$on('addform.submit', () => validateAddress(true));
        // Не передается аргумент status, поэтому будут установлены дефолтные значение и пойдет запрос на геокодирование
        // После клика по кнопке очистить идут запросы к геокодеру, хотя мы еще не выбрали категорию что бы отобразить карту
        // $scope.$on('addform.clear', () => clearGeoAddress());
        $scope.$watch(
          () => ({
            category: this.ad.category,
            locationPath: geoService.getLocationPath(),
            latitude: geoService.getCoordinates().lat,
            longitude: geoService.getCoordinates().lng,
            isAddressFullyInitialized,
            isMapReady,
            isAuthenticated: userService.isAuthenticated,
          }),
          (state) => {
            const {
              category,
              locationPath,
              isAddressFullyInitialized,
              isMapReady,
              isAuthenticated,
            } = state;

            if (
              // установлена категория
              category &&
              // locationPath ненулевой длины
              Array.isArray(locationPath) && locationPath.length &&
              // блок адреса полностью инициализирован
              isAddressFullyInitialized && (this.ad.id ? isMapReady : true) &&
              // пользователь аутентифицирован
              isAuthenticated
            ) {
              pubAvailService.checkPubAvail(category, locationPath);
            }
          },
          true,
        );

        // TODO: Перенести в jkService
        const addressListener = $scope.$watch(
          () => Array.isArray(this.ad.geo.address) && this.ad.geo.address.find(item => item.type === 'house'),
          (geoObj, oldGeoObj) => {
            if (!bsCenterService.isBSCategory()) {
              return;
            }

            if (!this.ad.geo.jk) {
              return;
            }

            /** Событие удаления адреса до дома (удален весь или часть адреса) */
            const isAddressRemoveEvent = !angular.isObject(geoObj) && angular.isObject(oldGeoObj);

            /** Событие смены адреса до дома */
            const isAddressChangeEvent =
              angular.isObject(geoObj) &&
              angular.isObject(oldGeoObj) &&
              geoObj.id !== oldGeoObj.id;

            /*
             * Если изменен адрес до дома, то проверяем, что адрес находится в границах ЖК
             *
             * Если был изменен корпус ЖК, то ЖК не будет отвязан текущим кодом, так как корпус
             * находится в границах ЖК
             *
             * Если был изменен адрес дома и конечный адрес находится вне ЖК,
             * то ЖК будет отвязан от объявления
            */
            if (isAddressChangeEvent) {
              jkService.getJkByGeoObj(geoObj).then(jk => {
                const isSameJKAddress = jk && jk.id === this.ad.geo.jk.id;

                if (!jk || !isSameJKAddress) {
                  jkService.clearJk();
                } else if (jk.houses && jk.houses.length === 1) {
                  /*
                   * Если в пине найден единственный корпус, то проставляем его в объявление
                   * Адрес корпуса обновится по вотчеру в jk.js и блок гео схлопнется
                  */
                  jkService.setJkHouse(jk.houses[0]);
                } else {
                  /* Во всех остальных случаях просто отвязываем ЖК, так как нет четкой схемы действий */
                  jkService.clearJk();
                }
              }).catch(() => {
                jkService.clearJk();
              });

              return;
            }

            if (isAddressRemoveEvent) {
              /*
               * Отвязываем ЖК, только если введен адрес корпуса у ЖК
               *
               * Это нужно, чтобы не отвязывать только что выбранный ЖК (у него корпус не выбран),
               * который стриггерил изменение адреса (удалился адрес до дома)
               *
               * Если пользователю не нужен ЖК, он удалит его в поле поиска ЖК и он отвяжется кодом ЖК
              */
              if (this.ad.geo.jk.house && this.ad.geo.jk.house.name) {
                jkService.clearJk();
              }
            }
          }
        );

        $scope.$on('$destroy', () => {
          addressListener();
        });
      }],
    controllerAs: 'addressCtrl',
    replace: true,
  };
});
